module.exports = __webpack_public_path__ + "img/Flag_of_Cyprus.83ec6982.svg";